import axios from '@_system/axios/axios.js'
export default {
	path: '/universalinvoice',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	getseller(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getseller', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	gettrade(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/gettrade', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	gettradedetail(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/gettradedetail', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	cargobilling(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/cargobilling', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	cargobillingresult(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/cargobillingresult', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/universalinvoice.universalinvoice', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
